// extracted by mini-css-extract-plugin
export default {"menu":"adminMenu_menu__h3sAc","menuText":"adminMenu_menuText__qFZAo","progress":"adminMenu_progress__-fF5M"};